<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import accionesCorrectivasPreventivasAPI from "../../../services/standards/accionesCorrectivasPreventiavs/accionesCorrectivasPreventivasAPI";
import employeeAPI from "../../../services/employee/employeeAPI";
import AccionesCorrectivasPagination from "../../../components/standard/accionesCorrectivas/AccionesCorrectivasPagination.vue";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "7.1.1 Acciones correctivas y/o preventivas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    AccionesCorrectivasPagination,
  },
  data() {
    return {
      title: "7.1.1 Acciones correctivas y/o preventivas",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Acciones correctivas y/o preventivas",
          active: true,
        },
      ],

      lista: [],
      loading: true,
      usersList: [],
      list: [],
      item: null,
      itemStatus: "No cumplido",
      lastId: 1,
      deleteCount: 0,
      search: "",
      file: null,
      submitted: false,
      itemData: null,
      acciones: {
        detection_date: null,
        area: null,
        evaluator: null,
        causes: null,
        action_type: null,
        description_action_plan: null,
        scheduled_date: null,
        actual_state: 'Abierta',
        execution_date: null,
        observation: null,
        file: null,
        corrective_actions_id: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
    };
  },
  validations: {
    acciones: {
      detection_date: {
        required,
      },
      evaluator: {
        required,
      },
      action_type: {
        required,
      },
      actual_state: {
        required,
      },
      corrective_actions_id: {
        required,
      },
      employee_id: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(57)//57-58-59-60
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 57)//57-58-59-60
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async changeItemStatus(itemStatus) {
      const items = [57];

      try {
        for (const itemId of items) {
          const itemChange = {
            companies_id: this.companyID,
            item_id: itemId,
            status: itemStatus,
          };
          await newScoresAPI.calculateScores(itemChange);
        }

        // Si todos los cálculos fueron exitosos, muestra el mensaje de éxito
        Swal.fire({
          title: "¡Éxito!",
          text: "¡Se ha cambiado el estado del ítem con éxito!",
          icon: "success",
          type: "success",
          confirmButtonClass: "btn btn-confirm mt-2",
        });

        setTimeout(() => window.location.reload(), 2000);
      } catch (error) {
        // Manejo del error en cualquiera de las operaciones
        Swal.fire({
          title: "¡Error!",
          text: "¡No se ha actualizado el estado del ítem!",
          type: "error",
          icon: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        });

        setTimeout(() => window.location.reload(), 2000);
        console.error(error);
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        if (!this.file) return true; // Si no hay archivo, continuar sin error

        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/7.1.1-4/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/7.1.1-4/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.acciones.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
        return false; // En caso de error, retornar falso para continuar con el guardado
      }
    },

    getUsers() {
      employeeAPI
        .getEmployeesOcupationalMedical(this.companyID)
        .then((res) => {
          this.usersList = res.employee;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getListA() {
      accionesCorrectivasPreventivasAPI
        .getList()
        .then((response) => {
          this.list = response.data
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    async save() {
      this.submitted = true;
      this.loading = true;

      try {
        // Intentar cargar el documento
        const response = await this.uploadDocument();

        // Verificar si el documento fue cargado o no hay archivo
        if (!response && this.file) {
          throw new Error("Error al cargar el documento");
        }

        // Guardar acciones correctivas/preventivas
        await accionesCorrectivasPreventivasAPI.save(this.acciones);

        // Cambiar estados de los ítems
        const items = [57];
        for (const itemId of items) {
          const itemChange = {
            companies_id: this.companyID,
            item_id: itemId,
            status: 'Pendiente',
          };
          await newScoresAPI.calculateScores(itemChange);
          this.sendNotification(76, itemId, true); // Enviar notificación después de calcular cada ítem
        }

        // Finalizar con éxito
        this.loading = false;
        Swal.fire({
          title: "¡Éxito!",
          text: "¡Se ha registrado con éxito!",
          icon: "success",
          type: "success",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } catch (error) {
        // Manejo de errores
        this.loading = false;
        Swal.fire({
          title: "Error",
          text: "¡No se ha podido registrar!",
          icon: "error",
          type: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        console.error(error);
      }
    },


    deleteAccion(id) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn btn-danger",
        cancelButtonClass: "btn btn-secondary ml-2",
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;

          // Eliminar la acción
          accionesCorrectivasPreventivasAPI.deleteAccion(id)
            .then(() => {
              if (this.deleteCount > 0) {
                this.deleteCount -= 1;
              }
              const newStatus = this.deleteCount > 0 ? "Pendiente" : "No Cumplido";

              // IDs a actualizar
              const itemIds = [57];

              // Generar las Promesas para actualizar los estados
              const updatePromises = itemIds.map((itemId) => {
                const itemChange = {
                  companies_id: this.companyID,
                  item_id: itemId,
                  status: newStatus,
                };
                return newScoresAPI.calculateScores(itemChange);
              });

              // Ejecutar todas las Promesas en paralelo
              Promise.all(updatePromises)
                .then(() => {
                  this.loading = false;
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha eliminado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                    buttonsStyling: false,
                  });
                  window.location.reload();
                })
                .catch((error) => {
                  this.handleError("¡Error al actualizar los estados!", error);
                });
            })
            .catch((error) => {
              this.handleError("¡Error al eliminar la acción!", error);
            });
        }
      });
    },

    // Función para manejar errores
    handleError(message, error) {
      this.loading = false;
      console.error(error);
      Swal.fire({
        title: "Error",
        text: message,
        type: "error",
        icon: "error",
        confirmButtonClass: "btn btn-confirm mt-2",
        buttonsStyling: false,
      });
    },

    getList() {
      accionesCorrectivasPreventivasAPI
        .getAll(this.companyID)
        .then((response) => {
          this.lista = response.data.data;
          if (response.data.data[0] && response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    // Descarga de formatos en blanco del ítem 7.1.1 (Promoción y Prevención) alojados en el bucket.
    descargarFormatoPP(tipo) {
      const base =
        "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/7.1.1";
      const file =
        tipo === "programa"
          ? "PROGRAMA_PROMOCION_Y_PREVENCION_7.1.1.docx"
          : "MATRIZ_PROMOCION_Y_PREVENCION_7.1.1.xlsx";
      window.open(`${base}/${file}`);
    },
  },

  mounted() {
    this.getItems();
    this.getList();
    this.getListA();
    this.getItemData();
    this.getUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe definir e implementar las acciones preventivas y/o correctivas
                      necesarias con base en los resultados de la supervisión, auditorias, inspecciones,
                      medición de los indicadores del Sistema de Gestión de SST, las recomendaciones del COPASST,
                      resultados de la revisión por la Alta Dirección del Sistema de Gestión de SST,
                      resultados de las investigaciones de los accidentes de trabajo, así como de las
                      enfermedades laborales y de requerimientos o recomendaciones de
                      autoridades administrativas y de las administradoras de riesgos laborales, entre otros.
                    </p>
                    <p class="text-justify">
                      Estas acciones se tomarán para prevenir o corregir una posible desviación del SG SST;
                      además, será necesario que la empresa realice seguimiento a su implementación,
                      para garantizar el cierre. En los casos de acciones derivadas de auditorías,
                      investigación de accidentes o enfermedades laborales o incumplimientos repetitivos
                      derivados de las inspecciones, se deberá realizar el respectivo análisis de causas
                      y para esto la empresa utilizará la metodología que desee (árbol de causas, lluvia de ideas,
                      causa-efecto, 5 porqué).
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="col-12 text-right m-b-0 d-flex justify-content-end flex-wrap align-items-center">
                <a :href="`/forms/procedimiento-acciones-correctivas`" underline class="mx-1">
                  Procedimiento de acciones correctivas y preventivas
                </a>
                <button :disabled="!allowAccess()"
                  @click="goPage(`/forms/estandares/${companyID}/acciones-promocion-prevencion`)"
                  class="btn btn-primary mx-1">
                  Reporte acciones de Promoción y Prevención
                </button>
                <button type="button" class="btn btn-outline-primary mx-1" @click="descargarFormatoPP('programa')">
                  <i class="bx bx-download"></i> Programa de P&amp;P (Word)
                </button>
                <button type="button" class="btn btn-outline-primary mx-1" @click="descargarFormatoPP('matriz')">
                  <i class="bx bx-download"></i> Matriz de P&amp;P (Excel)
                </button>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Fuente de acción">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="acciones.corrective_actions_id" required>
                      <option :value="null" disabled>Seleccione una opción</option>
                      <option v-for="item in list" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha detección" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date"
                      v-model="acciones.detection_date" required>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Área" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="text" maxlength="50"
                      v-model="acciones.area">
                    </b-form-input>

                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Evaluador" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="text" maxlength="30"
                      v-model="acciones.evaluator" required>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Causas" label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" maxlength="200"
                      v-model="acciones.causes">
                    </b-form-textarea>
                  </b-form-group>

                  <h5 class="col-md-12 px-2 pt-2">Planes de acción</h5>

                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3 pt-3" label="Tipo de acción">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="acciones.action_type" required>
                      <option :value="null" disabled>Seleccione una opción</option>
                      <option value="Preventiva">Preventiva</option>
                      <option value="Correctiva">Correctiva</option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Descripción plan de Acción" label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="trainingDate" maxlength="200"
                      v-model="acciones.description_action_plan">
                    </b-form-textarea>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha programada" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date"
                      v-model="acciones.scheduled_date">
                    </b-form-input>

                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha real de ejecución" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date"
                      v-model="acciones.execution_date">
                    </b-form-input>

                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Responsable">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="acciones.employee_id" required>
                      <option :value="null" disabled>Seleccione una opción</option>
                      <option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </option>
                    </select>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Estado actual">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="acciones.actual_state" required>
                      <option value="Abierta">Abierta</option>
                      <option value="Cerrada">Cerrada</option>
                    </select>
                  </b-form-group>
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" maxlength="200"
                      v-model="acciones.observation">
                    </b-form-textarea>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">
                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">
                                Fecha de creación
                              </th>
                              <th class="text-center align-middle">
                                Fecha de detección
                              </th>
                              <th class="text-center align-middle">
                                Responsable
                              </th>
                              <th class="text-center align-middle">
                                Fuente de la acción
                              </th>
                              <th class="text-center align-middle">
                                Estado actual
                              </th>
                              <th class="text-center align-middle">
                                Ver archivo
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.created_at) }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.detection_date) }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.full_name }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.name }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.actual_state }}
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                      background-color: transparent !important;
                                      border: none;
                                    " type="button" @click="gotoDigitalOcean(`${dato.file}`)">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>

                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " v-b-modal="`modal${dato.id}`">Editar</b-dropdown-item>
                                    <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">
                                          Advertencia
                                        </h4>
                                        <p class="mt-3">
                                          Al modificar esta información se
                                          quitará el puntaje correspondiente a
                                          este ítem y será necesario realizar
                                          nuevamente la validación por parte del
                                          usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()
                                          " type="button" class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white" :to="{
                                            path: `/forms/estandares/acciones-correctivas-preventivas-editar/${dato.id}`,
                                          }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="
                                          $bvModal.hide(`modal${dato.id}`)
                                          " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                          Cancelar
                                        </button>
                                      </div>
                                    </b-modal>
                                    <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"
                                      :to="{ path: `/forms/estandares/acciones-correctivas-preventivas-ver/${dato.id}` }">
                                      Ver
                                    </b-dropdown-item>

                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deleteAccion(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <AccionesCorrectivasPagination ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
